import styled from "@emotion/styled";
import { BookmarkButton, Box, BoxProps, SimpleGrid, UpvoteButton } from "@govlaunch/web";
import React from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "react-share";
import { IStoryFieldsFragment } from "../fragments/__generated__/StoryFieldsFragment.generated";

interface IStoryActionProps {
  story: Pick<IStoryFieldsFragment, "_id" | "slug" | "viewerDidBookmark" | "viewerDidUpvote">;
  onToggleUpvote: (story: Pick<IStoryFieldsFragment, "_id" | "slug" | "viewerDidBookmark" | "viewerDidUpvote">) => void;
  onToggleBookmark: (
    story: Pick<IStoryFieldsFragment, "_id" | "slug" | "viewerDidBookmark" | "viewerDidUpvote">,
  ) => void;
  iconsArrangement: "space-around" | "flex-start";
}

export default function StoryActions({
  story,
  onToggleUpvote,
  onToggleBookmark,
  iconsArrangement,
}: IStoryActionProps & BoxProps) {
  return (
    <div css={{ display: "flex", justifyContent: iconsArrangement, paddingTop: 5 }}>
      <IconWrapper>
        <FacebookShareButton url={getCurrentUrl() || `/stories/${story.slug}`}>
          <SimpleGrid alignItems="center" gridAutoFlow="column" gridColumnGap={2}>
            <FacebookIcon round={true} size={24} />
          </SimpleGrid>
        </FacebookShareButton>
      </IconWrapper>
      <IconWrapper>
        <TwitterShareButton url={getCurrentUrl() || `/stories/${story.slug}`}>
          <SimpleGrid alignItems="center" gridAutoFlow="column" gridColumnGap={2}>
            <TwitterIcon round={true} size={24} />
          </SimpleGrid>
        </TwitterShareButton>
      </IconWrapper>
      <IconWrapper>
        <LinkedinShareButton url={getCurrentUrl() || `/stories/${story.slug}`}>
          <SimpleGrid alignItems="center" gridAutoFlow="column" gridColumnGap={2}>
            <LinkedinIcon round={true} size={24} />
          </SimpleGrid>
        </LinkedinShareButton>
      </IconWrapper>
      <IconWrapper>
        <UpvoteButton upvoted={story.viewerDidUpvote} onClick={() => onToggleUpvote(story)} />
      </IconWrapper>
      <IconWrapper>
        <BookmarkButton bookmarked={story.viewerDidBookmark} onClick={() => onToggleBookmark(story)} />
      </IconWrapper>
    </div>
  );
}

function getCurrentUrl() {
  if (typeof window === "undefined") {
    return "";
  }

  return window.location.href;
}

const IconWrapper = styled("div")({
  marginRight: 4,
  marginLeft: 4,
  display: "flex",
  alignItems: "center",
});
